import React, { FC, MouseEventHandler } from 'react'

import { FormattedMessage } from 'react-intl'

import { LinkColor, RouterLink } from 'components/presentational/link'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

interface ShowMoreInterestProps {
  size: number | undefined
  to?: string
  onClick?: MouseEventHandler
  buttonMoreLikeColorLink?: boolean
}

export const ShowMoreInterest: FC<ShowMoreInterestProps> = ({
  onClick,
  size,
  to,
  buttonMoreLikeColorLink,
}) => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  if (size) {
    const content = (
      <FormattedMessage
        id="interest.more"
        values={{
          count: size,
        }}
        defaultMessage="все {count}"
      >
        {(text) => (
          <span style={{ whiteSpace: 'nowrap' }} data-name="all-count">
            {text}
          </span>
        )}
      </FormattedMessage>
    )

    if (!authorized && to) {
      return <RouterLink to={to}>{content}</RouterLink>
    }

    if (onClick) {
      return <LinkColor onClick={onClick}>{content}</LinkColor>
    }

    if (buttonMoreLikeColorLink) {
      return <LinkColor>{content}</LinkColor>
    }

    return content
  }
  return null
}
